import styled from 'styled-components';

import {
  fieldVariables,
  inputContainerBaseStyles,
  inputElStyles,
  inputLabelBaseStyles,
} from '@xemplo/input-utils';
import { TextEllipsis } from '@xemplo/style-constants';

export const Wrapper = styled.div`
  ${fieldVariables};
  width: var(--input-width);
`;

export const InputContainer = styled.div`
  ${inputContainerBaseStyles};
`;

export const Label = styled.label`
  ${inputLabelBaseStyles};
  display: flex;
  gap: 4px;
  right: 16px;
`;

export const LabelText = styled.span`
  ${TextEllipsis};
  min-width: 0;
  flex-shrink: 1;
`;

export const Optional = styled.span`
  font-weight: normal;
  color: var(--input-label-optional-text-color);
`;

/**
 * In order to achieve the ellipsis on the label
 * while also ensuring that the label text does not overlap
 * with the leading/trailing icons or error icon, we apply
 * additional right padding to the input element when these
 * icons are present. This allows the label to have enough
 * space to display the ellipsis correctly without being
 * obscured by the icons.
 *
 * The right value is essentially right padding + icon + gap for each icon type:
 * - padding 16px + Icon 24px + 8px gap = 48px for trailing icon
 * - padding 16px + Icon 24px + 8px gap + error icon 24px + 8px gap = 80px for trailing icon with error
 */
export const Input = styled.input`
  ${inputElStyles};

  &.has-trailing-icon + label,
  &.has-error-icon + label {
    right: 48px;
  }

  &.has-trailing-icon.has-error-icon + label {
    right: 80px;
  }
`;
